export const hotfundConstants = {
  FETCH_HOTFUND_START: 'FETCH_HOTFUND_START',
  FETCH_HOTFUND_SUCCESS: 'FETCH_HOTFUND_SUCCESS',
  FETCH_HOTFUND_FAILURE: 'FETCH_HOTFUND_FAILURE',

  UPDATE_HOTFUND_QUERIES: 'UPDATE_HOTFUND_QUERIES',
  UPDATE_HOTFUND_TABLE_COLUMNS: 'UPDATE_HOTFUND_TABLE_COLUMNS',
};
